import { ConnectedPosition, Overlay, OverlayModule, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-overlay-helper',
  standalone: true,
  imports: [OverlayModule],
  template: ` <ng-template #tabPanel cdkConnectedOverlay>
    <ng-content></ng-content>
  </ng-template>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayHelperComponent extends OnDestroyMixin {
  @Input() position: ConnectedPosition;
  @Input() overlayOrigin: any;
  @Output() overlayClosed = new EventEmitter<void>();
  @ViewChild('tabPanel') private tabPanel: TemplateRef<any>;

  isOpen = new BehaviorSubject(false);

  private tabPanelOverlayRef: OverlayRef;
  private tabPanelTemplatePortal: TemplatePortal;

  constructor(private readonly overlay: Overlay, private readonly viewContainerRef: ViewContainerRef) {
    super();
  }

  open(): void {
    this.isOpen.next(true);
    const origin =
      this.overlayOrigin?._elementRef?.nativeElement || this.overlayOrigin?.viewContainerRef.element.nativeElement;

    this.tabPanelOverlayRef = this.overlay.create({
      backdropClass: '',
      hasBackdrop: true,
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy: this.overlay
        .position()
        .flexibleConnectedTo(origin)
        .withPositions([this.position ?? { originX: 'end', originY: 'center', overlayX: 'start', overlayY: 'center' }]),
    });

    this.tabPanelTemplatePortal = new TemplatePortal(this.tabPanel, this.viewContainerRef);

    this.tabPanelOverlayRef.attach(this.tabPanelTemplatePortal);

    this.tabPanelOverlayRef
      .backdropClick()
      .pipe(untilComponentDestroyed(this))
      .subscribe(() => this.close());
  }

  close(): void {
    this.isOpen.next(false);
    if (this.tabPanelOverlayRef?.hasAttached()) this.tabPanelOverlayRef.detach();
    if (this.tabPanelTemplatePortal?.isAttached) this.tabPanelTemplatePortal.detach();
    this.overlayClosed.emit();
  }
}
